<template>
  <div class="col-lg-12 control-section h100-40 h-scroll">
    <div class='content-wapper h100' >
      <ejs-treegrid :dataSource='dataOfNoRealTaskCreateList' idMapping='id' parentIdMapping='parentItem' hasChildMapping='isParent' :treeColumnIndex='0'>
        <e-columns>
          <e-column field='measureObjName' :headerText='$t("Pm.measureObjName")' clipMode="EllipsisWithTooltip" textAlign='Center' width='24%'></e-column>
          <e-column field='counterName' :headerText='$t("Pm.counterName")' clipMode="EllipsisWithTooltip" textAlign='Center' width='24%'></e-column>
        </e-columns>
      </ejs-treegrid>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeasureListForNoRealTaskCreate',
  data() {
    return {
      dataOfNoRealTaskCreateList: [],
    }
  }
};
</script>

<style>

</style>
